<div class="dialog-header gbg">
    <div class="dialog-title fs20">View File</div>
    <button mat-icon-button (click)="close()" [tabIndex]="-1">
        <i class="fas fa-times fs20"></i>
    </button>
</div>
<div [className]="size.small ? 'dialog-body mobile-dialog-height' : 'dialog-body'">
    <div class="row">
        <div class="col-md-6 text-left my-auto">
            <span class="badge b-success c-white fs16 bold">{{filename}}</span>
        </div>
        <div class="col-md-6 text-right">

        </div>
    </div>
    <div class="row" style="min-height: 800px; min-width: 1000px; margin-top: 15px;">
        <div class="col-md-12" *ngIf="path !== ''">
            <iframe id="iframe" [src]="path | safe" style='width: 100%; height: 800px; border: 0 !important' seamless></iframe>
        </div>
    </div>
    <ngx-loading [show]="loading"></ngx-loading>
</div>
<div class="dialog-footer">
    <div class="row">
        <div class="col-6">
            <button mat-raised-button color="warn" (click)="newTab()">Full Screen</button>
        </div>
        <div class="col-6 text-right">
            <button mat-raised-button class="c-white" (click)="close()" color="accent"><i class="fas fa-times"></i>&nbsp;Close</button>
        </div>
    </div>
</div>